import { ReactElement } from "react";
import styled, { keyframes, css } from "styled-components";
import { useSelector } from "react-redux";
import { h } from "../../h";
import {
    getSyncIndicator,
    SyncIndicator,
} from "../../state/syncStatus.selectors";

export const syncIndicatorText = (indicator: SyncIndicator): string => {
    switch (indicator) {
        case `syncing`:
            return `Syncing...`;
        case `pending`:
            return `Sync pending...`;
        case `error`:
            return `Sync failed`;
        case `synced`:
            return `Synced`;
        default:
            return ``;
    }
};

const pulse = keyframes`
    0% { opacity: 1; }
    50% { opacity: 0.3; }
    100% { opacity: 1; }
`;

const SyncDotStyled = styled.div<{ indicator: SyncIndicator }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ theme, indicator }) =>
        indicator === `error`
            ? theme.colorWarning
            : indicator === `synced`
            ? theme.colorMain
            : theme.colorAccent};
    opacity: ${({ indicator }) => (indicator === `synced` ? 0.3 : 1)};
    ${({ indicator }) =>
        indicator === `syncing`
            ? css`
                  animation: ${pulse} 1s linear infinite;
              `
            : ``}
`;

export const SyncStatusDot = (): ReactElement | null => {
    const indicator = useSelector(getSyncIndicator);
    if (indicator == null) {
        return null;
    }
    return h(SyncDotStyled, {
        indicator,
        title: syncIndicatorText(indicator),
    });
};
